<script lang="ts">
    export let inverted = false
</script>

<span class="uppercase rounded-full text-[9px] py-1.5 px-3 pr-2.5 leading-tight relative bottom-0.5 tracking-[2px] whitespace-nowrap {inverted ? 'bg-white text-primary-500': 'gradient text-white'}">
    Early Reviewer
</span>

<style>
    .gradient {
        border-radius: 100px;
        background: var(--radial-blue, linear-gradient(180deg, rgba(154, 199, 252, 0.23) 0%, rgba(156, 255, 160, 0.30) 100%), #2768B5);
    }
</style>